import Flickity from 'flickity';
import 'flickity-fade';

const initTrailerGallery = () => {
    document.querySelectorAll('.js-trailer-gallery').forEach((gallery) => {
        const slides = gallery.querySelectorAll('.trailer-gallery-cell');

        if (slides.length < 2) {
            return;
        }

        new Flickity(gallery, {
            cellSelector: '.trailer-gallery-cell',
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: true,
            fade: true
        });
    });
};

initTrailerGallery();

